<template>
    <div>
        <div id="gs_top" onclick="">
            <div id="gs_md_ldg" style="display:none">Loading...</div>
            <div id="gs_md_err" style="display:none">The system can't perform the operation now. Try again later.</div>
            <div id="gs_md_s"></div>


            <el-drawer :visible.sync="drawer" :with-header="false" :direction="'ltr'">
                <div id="gs_hdr_drw" class="gs_md_ulr gs_md_ds gs_vis" role="dialog" tabindex="-1" data-shd="gs_hdr_drs" data-wfc="gs_hdr_drw_mnu" data-cfc="gs_hdr_mnu">
                    <div id="gs_hdr_drw_in">
                        <div id="gs_hdr_drw_top">
                            <a href="javascript:void(0)" id="gs_hdr_drw_mnu" role="button" aria-controls="gs_hdr_drw" aria-label="选项" class="gs_btnMNT gs_in_ib gs_btn_lrge">
                                <span class="gs_ico"></span>
                                <span class="gs_ia_notf"></span>
                                <span class="gs_lbl"></span>
                            </a>
                            <a id="gs_hdr_drw_lgo" aria-label="首页">
                                <img data-v-5d848f11="" src="/static/img/cyto_scholar.544b73a.png" style="padding-top: 11px; width: 126px;">
                            </a>
                        </div>
                        <div>
                            <div class="gs_hdr_drw_sec">
                                <a role="menuitem" class="gs_btnPRO gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">我的个人学术档案</span>
                                </a>
                                <a role="menuitem" class="gs_btnL gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">我的图书馆</span>
                                </a>
                                <a role="menuitem" class="gs_btnM gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">快讯</span>
                                </a>
                                <a role="menuitem" class="gs_btnJ gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">统计指标</span>
                                </a>
                            </div>
                            <div class="gs_hdr_drw_sec">
                                <a role="menuitem" class="gs_btnP gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                    <span class="gs_ico"></span>
                                    <span class="gs_ia_notf"></span>
                                    <span class="gs_lbl">设置</span>
                                </a>
                            </div>
                        </div>
                        <div id="gs_hdr_drw_bot" class="gs_hdr_drw_sec">
                            <a class=" gs_in_ib gs_md_li gs_md_lix gs_in_gray">
                                <span class="gs_ico"></span>
                                <span class="gs_ia_notf"></span>
                                <span class="gs_lbl"></span>
                            </a>
                            <img class="gs_hdr_pp" width="24" height="24">
                        </div>
                    </div>
                </div>
            </el-drawer>


            <div id="gs_hdr" role="banner">
                <a href="javascript:void(0)" id="gs_hdr_mnu" @click="drawer = type === 1 ? !drawer : false" role="button" aria-controls="gs_hdr_drw"
                    class="gs_btnMNT gs_in_ib gs_btn_lrge">
                    <span class="gs_ico"></span>
                    <span class="gs_ia_notf"></span>
                    <span class="gs_lbl"></span>
                </a>
                <router-link :to="'scholar'" id="gs_hdr_lgo" class="gs_hdr_dso" aria-label="Homepage">
                    <img src="../assets/cyto_scholar.png" style="padding-top: 11px; width: 126px;" />
                </router-link>
                <!-- <div id="gs_hdr_md">
                    <router-link to="/paper/polish">
                        <img src="../assets/润色-百.png" style="width: 200px;">
                    </router-link>
                </div> -->
                <div id="gs_hdr_act" style="padding:10px;">
                    <AccountWiget></AccountWiget>
                </div>
            </div>

            <div id="gs_bdy" v-loading="false">

                <div id="gs_bdy_ccl" role="main" v-html="bodyHtml">


                </div>
            </div>
            <div id="gs_ftr_sp" role="presentation"></div>
            <!-- <div id="gs_ftr" role="contentinfo">
                <div id="gs_ftr_rt"><a>帮助</a><a>隐私</a><a>条款</a></div>
            </div> -->
        </div>
        <!-- <remote-js src="https://cdn.jsdelivr.net/gh/pcooksey/bibtex-js@1.0.0/src/bibtex_js.min.js"></remote-js> -->

    </div>
</template>

<script>
import request, { BaseUrl } from "../utils/request";
import bibtexParse from '@orcid/bibtex-parse-js';
import { Base64 } from 'js-base64';
import AccountWiget from "./AccountWiget";
import axios from "axios";

export default {
    name: "PaperSearchCitations",
    components: {
        AccountWiget,
        'remote-js': {
            render(createElement) {
                return createElement('script', { attrs: { type: 'text/javascript', src: this.src } });
            },
            props: {
                src: { type: String, required: true },
            },
        },
    },
    data() {
        return {
            user: '',
            bodyHtml: '',
            gsHdrTsbDisabled: false,
            type: 0,
            query: '',
            advQuery: {
                pos: 'any'
            },
            /*tree: [{"id":"1","label":"总结本篇","children":[{"id":"2","label":"总结标题"},{"id":"3","label":"总结内容"}]}],*/
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            page: 1,
            scisbd: '',
            sortType: 0,
            langType: 0,
            articleType: 0,
            lr: '',
            data: null,
            lastTimer: 0,
            scihubMirror: 0,
            data1: null,
            total: 0,
            drawer: false,
            showAdvance: false,
            showCustomTime: false,
            citeBody: '',
            isShowCite2: false,
            dialogCiteVisible: false,
            dialogSummaryVisible: false,

            summaryDetail: {
                date: '',
                author: '',
                doi: '',
                source: '',
                date: '',
                text: '',
                text_cn: '',
            },
            currentCiteStyle: null,
            currentCiteContent: '',
            currentCiteList: {
                'MLA': '',
                'APA': '',
                'Chicago': '',
            },
            base64Bib: '',
            base64End: '',
            startTime: 0,
            endTime: 0,
            customTimeVisible: false,
            customTimeForm: {
                start: '',
                end: '',
            },
            Hidden1: 'block'
        }
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        '$route': 'updateQuery'
    },
    created() {
        this.updateQuery()
    },
    methods: {
        updateQuery() {
            this.user = this.$route.query.user
            console.log({ user: this.user });
            axios.create({
                baseURL: 'https://serverp.dotaindex.com/', // api 的 base_url
                // baseURL: 'http://127.0.0.1:8002', // api 的 base_url
                timeout: 40000 // 请求超时时间
            })({
                url: "api/searchPaper/citations",
                method: "get",
                params: { user: this.user },
            }).then((res) => {
                console.log({ res })
                this.bodyHtml = res.data;
                this.gsHdrTsbDisabled = false

            }).catch(error => {
                console.log({ error });
                console.log(error.response.status);
            })
        },
        computeIfColor(vIf) {
            if (vIf > 20) return '#FF000082'
            if (vIf > 10) return '#FF66CC82'
            if (vIf > 5) return '#0099FF82'
            if (vIf > 3) return '#f3e10a82'
            if (vIf > 0) return '#33CC3382'
            return '#A6A6A682'
        },
        computePartitionColor(p) {
            p = p.replace(/\D/g, "")
            if (p == 1) return '#FF006682'
            if (p == 2) return '#0099FF82'
            if (p == 3) return '#f3e10a82'
            return '#33CC3382'
        },
        getShortUrl(url) {
            if (!url) return ''
            return url.split('/')[2]
        },
        loadData() {
            clearTimeout(this.lastTimer)
            this.data1 = null

            var retryTime = 0
            var fetchResult = () => {

                this.gsHdrTsbDisabled = true
                axios.create({
                    baseURL: 'https://serverp.dotaindex.com/', // api 的 base_url
                    // baseURL: 'http://127.0.0.1:8002', // api 的 base_url
                    timeout: 40000 // 请求超时时间
                })({
                    url: "api/searchPaper/google",
                    method: "get",
                    params: params,
                }).then((r) => {
                    console.log({ r })
                    r = r.data
                    this.data1 = r;
                    this.total = r.total

                    this.gsHdrTsbDisabled = false
                    if (r.data != undefined && r.data.length == 0) {
                        if (retryTime++ < 10) {
                            this.data1 = null
                            this.lastTimer = setTimeout(fetchResult, 1000);
                        }
                    }
                }).catch(error => {
                    console.log({ error });
                    console.log(error.response.status);

                    this.data1 = []
                    if (error.response.status == 400) {
                        retryTim = 1
                        this.gsHdrTsbDisabled = false
                    } else {

                        if (retryTime++ < 10) {
                            this.data1 = null
                            this.lastTimer = setTimeout(fetchResult, 1000);
                        }

                        this.gsHdrTsbDisabled = false
                    }

                });
            }
            fetchResult()


        },
        imgClick() {
            window.open('https://sci.justscience.cn/chatgpt')
        }
    }
}

</script>
<style lang="less" scoped>
@import '../styles/pages/PaperSearchCitations.less';
</style>


// WEBPACK FOOTER //
// src/components/PaperSearchCitations.vue